import { Accordion, Box } from "@mantine/core"
import { CalendarTalentFilter } from "./CalendarTalentFilter";
import { Icons } from "../ui/Icons";
import { Icon } from "@iconify/react";
import { CalendarVenueFilter } from "./CalendarVenueFilter";
// import { CalendarAreaFilter } from "./CalendarAreaFilter";

export function CalendarSidebar() {

    return (
        <Box>
            <Accordion
                variant="filled"
                defaultValue={["talent"]}
                multiple
            >
                <Accordion.Item value="talent">
                    <Accordion.Control
                        icon={<Icon icon={Icons.talent} width={22} />}
                    >
                        Filter by Talent
                    </Accordion.Control>
                    <Accordion.Panel>
                        <CalendarTalentFilter />
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item value="venue">
                    <Accordion.Control
                        icon={<Icon icon={Icons.venue} width={22} />}
                    >
                        Filter by Venue
                    </Accordion.Control>
                    <Accordion.Panel>
                        <CalendarVenueFilter />
                    </Accordion.Panel>
                </Accordion.Item>
                {/* <Accordion.Item value="area">
                    <Accordion.Control
                        icon={<Icon icon={Icons.area} width={22} />}
                    >
                        Filter by Area
                    </Accordion.Control>
                    <Accordion.Panel>
                        <CalendarAreaFilter/>
                    </Accordion.Panel>
                </Accordion.Item> */}
            </Accordion>

        </Box>
    )

}